// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2-ue7","list":"PatternAutocomplete_list__oczhi"};